/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { modifier } from 'ember-modifier';

export default class UiTabsTabComponent extends Component {
  didInstall = modifier(
    () => {
      this.args.onActivate?.();
    },
    { eager: false }
  );
}
